import { useExaminerDetails } from './useExaminerDetails'

export function useArtUnitId() {
  const details = useExaminerDetails()

  return details.context.data?.artUnits[0]?.id ?? null
}
